import { DataExchangeKind, JpkVatSubkind, PackageOfDocumentsSubkind } from "../data-exchange-kind";
import { PurchaseDocumentsDateSelectionKind } from "../purchase-date-selection-kind";
import { SalesDocumentsDateSelectionKind } from "../sales-date-selection-kind";
import { SentDocumentsFilteringPolicy } from "../sent-documents-filtering-policy";

export class AccountancyCreateDTO {
	public readonly kind?: DataExchangeKind | JpkVatSubkind | PackageOfDocumentsSubkind | null;
	public readonly from: Date;
	public readonly to: Date;
	public readonly purchaseSelection: PurchaseDocumentsDateSelectionKind;
	public readonly salesSelection: SalesDocumentsDateSelectionKind;
	public readonly sentDocumentsFiltering: SentDocumentsFilteringPolicy;
	public readonly ids: number[];
	public readonly parameters?: {} | null;
}
